export default "__VITE_ASSET__c6861deb__"